import axios from "@/lib/axios";

export type RemoveUserRequestParams = {
  companyId: string;
  userId: string;
};

export type RemoveUserResponse = void;

export const removeUser = (params: RemoveUserRequestParams) =>
  axios
    .delete<RemoveUserResponse>(
      `/v1/companies/${params.companyId}/users/${params.userId}`,
    )
    .then((res) => res.data);
